import {
  AutomationItemStatus,
  AutomationItemType,
  AutomationRequirementType,
  DateQuestionInitialState,
  SubjectStatus,
  WeekDay,
} from '@fdha/graphql-api-admin';
import { ChipColor } from '@fdha/web-ui-library';

export const automationItemLabelByValue: Record<AutomationItemType, string> = {
  [AutomationItemType.Sachets]: 'Sachet request',
  [AutomationItemType.FrozenFood]: 'Quick Ship request',
  [AutomationItemType.WelcomeBinder]: 'Welcome Binder request',
  [AutomationItemType.WelcomeKit]: 'Welcome Kit request',
  [AutomationItemType.ContingencyMeal]: 'Contingency Meal request',
};

export const automationItemStatusLabelByValue: Record<
  AutomationItemStatus,
  string
> = {
  [AutomationItemStatus.Checking]: 'Checking...',
  [AutomationItemStatus.Incomplete]: 'Incomplete ',
  [AutomationItemStatus.Invalid]: 'Invalid',
  [AutomationItemStatus.Scheduled]: 'Scheduled',
  [AutomationItemStatus.Triggered]: 'Triggered',
  [AutomationItemStatus.Error]: 'Error',
};

export const automationRequirementLabelByValue: Partial<
  Record<AutomationRequirementType, string>
> = {
  [AutomationRequirementType.DaysOnDiet]: 'Days on diet',
  [AutomationRequirementType.DietPlan]: 'Diet plan',
  [AutomationRequirementType.TrialStatus]: 'Trial status',
  [AutomationRequirementType.MedicalFoodStartDate]: 'Medical food start date',
  [AutomationRequirementType.Sachets]: 'Sachets',
  [AutomationRequirementType.SnacksAndSides]: 'Snacks and sides per day',
};

export const dateQuestionInitialStateLabelByValue: Record<
  DateQuestionInitialState,
  string
> = {
  [DateQuestionInitialState.PreloadedWithCurrentDate]: 'User current date',
  [DateQuestionInitialState.NoPreloadedDate]: 'No preloaded date',
};

export const weekdayLabelByValue: Record<WeekDay, string> = {
  [WeekDay.Mon]: 'Monday',
  [WeekDay.Tue]: 'Tuesday',
  [WeekDay.Wed]: 'Wednesday',
  [WeekDay.Thu]: 'Thursday',
  [WeekDay.Fri]: 'Friday',
  [WeekDay.Sat]: 'Saturday',
  [WeekDay.Sun]: 'Sunday',
};

export const subjectStatusColorByValue: Record<SubjectStatus, ChipColor> = {
  [SubjectStatus.Discontinued]: 'error',
  [SubjectStatus.Ongoing]: 'success',
  [SubjectStatus.Screening]: 'info',
  [SubjectStatus.StudyCompleted]: 'error',
  [SubjectStatus.ScreenFailed]: 'error',
  [SubjectStatus.CoachApproved]: 'info',
  [SubjectStatus.Draft]: 'warning',
};
